module.exports = __webpack_public_path__ + "img/test10.fb76e3ee.png";